import React, {useEffect} from "react";
import{useNavigate} from "react-router-dom";

// Context get v
import { useState, useContext } from "react";
import UserContext from "../Context/UserContext";
// End Context get v

const withAuth = (WrappedComponent) => {
    const WithAuthComponent = (props) => {

        // Context
        const { userIN } = useContext(UserContext);
        // End Context

        const navigate = useNavigate();
        const isAuth = true;

        useEffect(() => {
            console.log("User Authentication :", userIN);

            
            // if(!isAuth){
            // Context
                if(!userIN){
                    // End Context
                navigate("/");
            }
        }, [userIN, navigate]);
    // }, [isAuth, navigate]);

        return userIN ? <WrappedComponent {...props}/> : <div>Null</div>;
        // return isAuth ? <WrappedComponent {...props}/> : <div>Null</div>;
        
    };

    return WithAuthComponent;
}

export default withAuth;